import React, { useState, useEffect } from 'react';
import date from '../utill/dateTime';
import { getMasterData } from "./masterDataCache";

const DetailedProductionTable = ({ id, data = [], reasons = [], qualityReason = [], compList: compListProp }) => {
    const [fetchedCompList, setFetchedCompList] = useState([]);

    // Prefer the component list supplied by the parent. This avoids a race
    // condition where a freshly mounted (hidden) export table starts its own
    // async fetch and the Excel export reads the DOM before the list arrives,
    // which made Component Alias intermittently serialize as "N/A".
    const compList = (compListProp && compListProp.length > 0) ? compListProp : fetchedCompList;

    useEffect(() => {
        // Only self-fetch when the parent did not provide the list.
        if (compListProp && compListProp.length > 0) return;
        getMasterData("component").then((data) => ({ data }))
            .then((result) => {
                setFetchedCompList(result.data);
            })
            .catch((err) => {
                // console.log(err);
            })
    }, [compListProp])

    // helper to detect PartOfFamily truthy values
    const isPartOfFamilyValue = (v) => {
        return v === true || v === 'true' || v === 1 || v === '1';
    }

    // whether any row is a family mold job
    const hasFamily = Array.isArray(data) && data.some(one => isPartOfFamilyValue(one.PartOfFamily));

    const getRowSpan = (data1) => {
        let ReasonArr = [...(data1.Downtime || [])]
        let arr = []
        let returnArr = []
        for (let i = 0; i < ReasonArr.length; i++) {
            let arr1 = []
            arr1.push(ReasonArr[i])
            for (let j = i + 1; j < ReasonArr.length; j++) {
                if (ReasonArr[i].DowntimeReason == ReasonArr[j].DowntimeReason) {
                    arr1.push(ReasonArr[j]);
                    ReasonArr.splice(j, 1)
                    j--;
                }
            }
            arr.push(arr1);
        }
        arr.forEach(one => {
            returnArr.push(one.length);
        })
        returnArr.sort(function (a, b) {
            return b - a;
        });
        if (returnArr.length > 0) {
            return returnArr[0]
        } else {
            return 1;
        }
    }

    const getDowntimeReason = (downsReason, limit) => {
        let ReasonArr = [...(downsReason || [])]
        console.log(ReasonArr, "ReasonArr");

        let arr = []
        let returnArr = []
        for (let i = 0; i < ReasonArr.length; i++) {
            let arr1 = []
            arr1.push(ReasonArr[i])
            for (let j = i + 1; j < ReasonArr.length; j++) {
                if (ReasonArr[i].DowntimeReason == ReasonArr[j].DowntimeReason) {
                    arr1.push(ReasonArr[j]);
                    ReasonArr.splice(j, 1)
                    j--;
                }
            }
            arr.push(arr1);
        }

        for (let j = 0; j < limit; j++) {
            if (j < limit) {
                let arr2 = []
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i][j]) {
                        arr2.push(arr[i][j])
                    }
                }
                returnArr.push(getDowntimeReason1(arr2))
            }
        }

        return returnArr;
    }
    const getDowntimeReason1 = (ReasonArr) => {
        let returnArr = []
        if (reasons.length == 0) {
            let obj = {}
            obj.Duration = null;
            obj.From = null
            obj.Till = null
            obj.Remarks = null
            returnArr.push(obj)
        } else {
            reasons.forEach((one1) => {
                let filterReason = ReasonArr.filter(obj => obj.DowntimeReason == one1.Reason)
                if (filterReason.length > 0) {
                    returnArr.push({ ...filterReason[0] })
                } else {
                    let obj = {}
                    obj.Duration = null;
                    obj.From = null
                    obj.Till = null
                    obj.Remarks = null
                    returnArr.push(obj)
                }
            })
        }

        return returnArr;
    }

    const getQualityReason = (ReasonArr) => {
        let returnArr = []

        if (qualityReason.length == 0) {
            returnArr.push({ Reason: 'default', Count: 0 });
        } else {
            qualityReason.forEach((one1) => {
                let filterReason = (ReasonArr || []).filter(obj => obj.Reason == one1.QualityReason)
                if (filterReason.length > 0) {
                    returnArr.push({ ...filterReason[0] })
                } else {
                    let obj = { Reason: one1.QualityReason, Count: 0 }
                    returnArr.push(obj)
                }
            })
        }

        return returnArr;
    }

    const getAliaName = (Component) => {
        let component = [...compList];
        component = component.filter((one) => one.ComponentId == Component)
        if (component.length > 0 && component[0].Alias) {
            return component[0].Alias
        } else {
            return 'N/A'
        }
    }


    return (<>
        {/* Legend + CSS (legend shows only when hasFamily is true) */}
        <style>{`
            .part-of-family td { background-color: #FFEB9C !important; }
            .dp-legend { display:flex; align-items:center; gap:8px; margin-bottom:8px; font-size:0.95rem; }
            .dp-legend-box { width:18px; height:18px; background-color:#FFEB9C; border:1px solid #d0c09a; display:inline-block; border-radius:2px; }
            .dp-legend-text { font-weight:600; }
        `}</style>

        {hasFamily && (
            <div className="dp-legend" aria-hidden="false">
                <span className="dp-legend-box" aria-hidden="true" />
                <span className="dp-legend-text">
                    <strong>Note:</strong> Highlighted rows indicate <strong>Family Job</strong>.
                </span>
            </div>
        )}

        <table id={id} className="table table-sm table-bordered  small table-striped scrollable-table" style={{ padding: 0 }}>
            <thead className='small text-center border'>
                <tr className='text-center align-self-center table-primary sticky-header'>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3' >Date</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Shift</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment Group</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Batch Number</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Job Number</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Component</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Component Alias</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Operation</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Tool</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Parts Per Cycle</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Operator</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Customer</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Job From Date</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Job From Time</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Job Till Date</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Job Till Time</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Remarks</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Job Duration (mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Break Duration(mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Planned Prod Time (mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment StartDate</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment StartTime</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment StopDate</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment StopTime</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Cycles Run</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Parts Produced</th>





                    <th style={{ verticalAlign: 'middle' }} colSpan={reasons.length * 6}>Downtime Reasons </th>


                    <th style={{ verticalAlign: 'middle' }} rowSpan='3' >Unplanned Downtime Duration (mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3' >Planned Downtime Duration (mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Total Downtime Duration (mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Equipment RunTime (mins)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Ideal SPM</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Average SPM</th>

                    <th style={{ verticalAlign: 'middle' }} colSpan={qualityReason.length}>Quality Reasons</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Total Rejection (no. of units)</th>

                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Availability (%)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Performance (%)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>QualityFactor (%)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>OEE (%)</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Target Parts</th>
                    <th style={{ verticalAlign: 'middle' }} rowSpan='3'>Accepted Parts</th>
                </tr>

                <tr className='table-primary sticky-header' >

                    {reasons.length > 0 ? reasons.map((one, idx) => {
                        return <th key={`r-${idx}`} colSpan='6' style={{ verticalAlign: 'middle' }} ><div ><span>{one.Reason}</span></div></th>
                    }) : ''}

                    {qualityReason.length > 0 ? qualityReason.map((one, idx) => {
                        return <th key={`q-${idx}`} rowSpan={2} style={{ verticalAlign: 'middle' }} ><div ><span>{one.QualityReason}</span></div></th>
                    }) : ''}

                </tr>
                <tr className='table-primary sticky-header2' >
                    {reasons.length > 0 ? reasons.map((one, idx) => {
                        return <React.Fragment key={`rh-${idx}`}>
                            <th style={{ verticalAlign: 'middle' }}  >From Date</th>
                            <th style={{ verticalAlign: 'middle' }} >From Time</th>
                            <th style={{ verticalAlign: 'middle' }}  >Till Date</th>
                            <th style={{ verticalAlign: 'middle' }} >Till Time</th>
                            <th style={{ verticalAlign: 'middle' }}  >Duration (mins)</th>
                            <th style={{ verticalAlign: 'middle' }}  >Remarks</th>
                        </React.Fragment>
                    }) : ''}
                </tr>
            </thead>


            <tbody>
                {data.map((one, rowIdx) => {
                    const rowSpan = getRowSpan(one);
                    const isFamily = isPartOfFamilyValue(one.PartOfFamily);

                    return (
                        <React.Fragment key={`row-${rowIdx}`}>
                            <tr className={isFamily ? 'part-of-family' : ''}>
                                <td rowSpan={rowSpan}>{date.getDateFormat(one.From)}</td>
                                <td rowSpan={rowSpan}>{one.Shift}</td>
                                <td rowSpan={rowSpan}>{one.EquipmentGroup}</td>
                                <td rowSpan={rowSpan}>{one.Equipment}</td>
                                <td rowSpan={rowSpan}>{one.BatchNumber}</td>
                                <td rowSpan={rowSpan}>{one.JobNumber}</td>
                                <td rowSpan={rowSpan}>{one.Component}</td>
                                <td rowSpan={rowSpan}>{getAliaName(one.Component)}</td>
                                <td rowSpan={rowSpan}>{one.Operation}</td>
                                <td rowSpan={rowSpan}>{(one.Tool == 'null' || one.Tool == undefined) ? '-' : one.Tool}</td>
                                <td rowSpan={rowSpan}>{one.PartsPerCycle}</td>
                                <td rowSpan={rowSpan}>{one.Operator}</td>
                                <td rowSpan={rowSpan}>{(one.CustomerName == 'null' || one.CustomerName == null || one.CustomerName == undefined) ? '-' : one.CustomerName}</td>
                                <td rowSpan={rowSpan}>{date.getDateFormat(one.JobFrom)}</td>
                                <td rowSpan={rowSpan}>{date.getTime(one.JobFrom)}</td>
                                <td rowSpan={rowSpan}>{date.getDateFormat(one.JobTill)}</td>
                                <td rowSpan={rowSpan}>{date.getTime(one.JobTill)}</td>
                                <td rowSpan={rowSpan}>{one.JobRemarks}</td>
                                <td rowSpan={rowSpan}>{one.JobDuration}</td>
                                <td rowSpan={rowSpan}>{one.BreakDuration}</td>
                                <td rowSpan={rowSpan}>{one.PlannedProdTime}</td>
                                <td rowSpan={rowSpan}>{date.getDateFormat(one.EquipmentStartDateTime)}</td>
                                <td rowSpan={rowSpan}>{date.getTime(one.EquipmentStartDateTime)}</td>
                                <td rowSpan={rowSpan}>{date.getDateFormat(one.EquipmentStopDateTime)}</td>
                                <td rowSpan={rowSpan}>{date.getTime(one.EquipmentStopDateTime)}</td>
                                <td rowSpan={rowSpan}>{one.CyclesRun}</td>
                                <td rowSpan={rowSpan}>{one.PartsProduced ? one.PartsProduced : '-'}</td>

                                {getDowntimeReason(one.Downtime, rowSpan).length > 0 ? getDowntimeReason(one.Downtime, rowSpan).map((o, i) => {
                                    if (i == 0) {
                                        return o.map((r, j) => {
                                            return (
                                                <React.Fragment key={`d-${rowIdx}-${i}-${j}`}>
                                                    <td>{r.From ? date.getDateFormat(r.From) : '-'}</td>
                                                    <td>{r.From ? date.getTime(r.From) : '-'}</td>
                                                    <td>{r.Till ? date.getDateFormat(r.Till) : '-'}</td>
                                                    <td>{r.Till ? date.getTime(r.Till) : '-'}</td>
                                                    <td>{r.Duration ? Math.ceil(r.Duration / 60) : '-'}</td>
                                                    <td>{r.Remarks ? r.Remarks : '-'}</td>
                                                </React.Fragment>
                                            )
                                        })
                                    }
                                    return null;
                                }) : ''}

                                <td rowSpan={rowSpan}>{one.UnplannedDowntimeDuration ? Math.ceil(one.UnplannedDowntimeDuration / 60) : '-'}</td>
                                <td rowSpan={rowSpan}>{one.PlannedDowntimeDuration ? Math.ceil(one.PlannedDowntimeDuration / 60) : '-'}</td>
                                <td rowSpan={rowSpan}>{one.TotalDowntimeDuration ? Math.ceil(one.TotalDowntimeDuration / 60) : '-'}</td>
                                <td rowSpan={rowSpan}>{one.EquipmentRunTime ? one.EquipmentRunTime : '-'}</td>
                                <td rowSpan={rowSpan}>{one.IdealSPM ? one.IdealSPM : '-'}</td>
                                <td rowSpan={rowSpan}>{one.AverageSPM ? one.AverageSPM : '-'}</td>

                                {getQualityReason(one.RejectionReason).length > 0 ? getQualityReason(one.RejectionReason).map((r, qi) => {
                                    return <td key={`q-${rowIdx}-${qi}`} rowSpan={rowSpan}>{r.Count ? r.Count : '0'}</td>
                                }) : <td rowSpan={rowSpan}>0</td>}

                                <td rowSpan={rowSpan}>{one.TotalRejection ? one.TotalRejection : '0'}</td>
                                <td rowSpan={rowSpan}>{one.Availability ? one.Availability : '-'}</td>
                                <td rowSpan={rowSpan}>{one.Performance ? one.Performance : '-'}</td>
                                <td rowSpan={rowSpan}>{one.QualityFactor ? one.QualityFactor : '-'}</td>
                                <td rowSpan={rowSpan}>{one.OEE ? one.OEE : '-'}</td>
                                <td rowSpan={rowSpan}>{one.TargetParts ? one.TargetParts : '-'}</td>
                                <td rowSpan={rowSpan}>{one.AcceptedParts ? one.AcceptedParts : '-'}</td>

                            </tr>

                            {getDowntimeReason(one.Downtime, rowSpan).length > 0 ? getDowntimeReason(one.Downtime, rowSpan).map((o, idx) => {
                                if (idx > 0) {
                                    return (
                                        <tr key={`extra-${rowIdx}-${idx}`} className={isFamily ? 'part-of-family' : ''}>
                                            {o.map((r, j) => {
                                                return (
                                                    <React.Fragment key={`extra-d-${rowIdx}-${idx}-${j}`}>
                                                        <td>{r.From ? date.getDateFormat(r.From) : '-'}</td>
                                                        <td>{r.From ? date.getTime(r.From) : '-'}</td>
                                                        <td>{r.Till ? date.getDateFormat(r.Till) : '-'}</td>
                                                        <td>{r.Till ? date.getTime(r.Till) : '-'}</td>
                                                        <td>{r.Duration ? Math.ceil(r.Duration / 60) : '-'}</td>
                                                        <td>{r.Remarks ? r.Remarks : '-'}</td>
                                                    </React.Fragment>
                                                )
                                            })}
                                        </tr>
                                    )
                                }
                                return null;
                            }) : ''}

                        </React.Fragment>
                    )
                })}
            </tbody>
        </table>
    </>);
}

export default DetailedProductionTable;